// Subscription tier definitions
export const subscriptionTiers = [
  {
    tier: "Free",
    lookupKey: "price_free",
    price: "0",
    features: [
      "Basic access to platform",
      "Limited API requests (100/day)",
      "Community support",
      "Standard documentation"
    ],
    buttonText: "Get Started Free",
    isPopular: false
  },
  {
    tier: "Developer",
    lookupKey: "price_developer",
    price: "29",
    features: [
      "Full platform access",
      "Increased API requests (10,000/day)",
      "Email support",
      "Advanced documentation",
      "Development environment"
    ],
    buttonText: "Subscribe Now",
    isPopular: true
  },
  {
    tier: "Business",
    lookupKey: "price_business",
    price: "99",
    features: [
      "Enterprise-grade access",
      "Unlimited API requests",
      "Priority email & phone support",
      "Custom integration support",
      "Multiple environments",
      "Team collaboration tools"
    ],
    buttonText: "Start Business Plan",
    isPopular: false
  },
  {
    tier: "Enterprise",
    lookupKey: "price_enterprise",
    price: "299",
    features: [
      "White-label solutions",
      "Dedicated infrastructure",
      "24/7 Premium support",
      "SLA guarantees",
      "Custom feature development",
      "Enterprise security features",
      "Onboarding assistance"
    ],
    buttonText: "Contact Sales",
    isPopular: false
  }
];
